<template>
  <div
    v-if="label"
    class="truncate"
    :class="
      typography === 'quiet'
        ? 'text-caption font-medium text-stone-500'
        : 'text-caption-small font-semibold uppercase tracking-widest text-teal-700'
    "
  >
    {{ label }}
  </div>
</template>

<script setup lang="ts">
import type { ProductCardTypography } from '~/utils/productCardMapper'

const { label, typography = 'standard' } = defineProps<{
  label: string
  typography?: ProductCardTypography
}>()
</script>
